import StoreIcon from '@mui/icons-material/Store';

import { useUser } from '@app/context/UserContext';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { MultiTenantReport } from './MultiTenantReport';
import { MultiTenantTable } from './MultiTenantTable';
import './multitenant.sass';

export function MultiTenant() {
  const { user } = useUser();
  const { t } = useTranslation();

  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const reportTenant = searchParams.get('reportTenant');
  const reportOpen = !!reportTenant;

  const closeReport = () => {
    const sp = new URLSearchParams(location.search);
    sp.delete('reportTenant');
    history.replace({ pathname: location.pathname, search: sp.toString() });
  };

  return (
    <div className="dtMultiTenant flex flex-col gap-[10px]">
      <div className="dtRouteDashboard__itemTitle flex flex-row items-center gap-[10px]">
        <StoreIcon />
        <div className="dtRouteDashboard__itemTitleInput grow">{t('dashboard.multitenant')}</div>
        <span className="whitespace-nowrap text-2xl">
          {user?.companies.length} / {user?.maxTenants}
        </span>
      </div>
      {reportOpen && (
        <div className="flex justify-end">
          <button onClick={closeReport} className="text-sm underline text-primary-root">
            Zurück
          </button>
        </div>
      )}
      {reportOpen ? <MultiTenantReport /> : <MultiTenantTable />}
    </div>
  );
}
